import { FormStructure } from "./FormRenderer";

export const createDefaultForm = (): FormStructure => {
  return {
    title: "",
    description: "",
    fields: [
      {
        id: "field_1",
        type: "text",
        text: "",
        subtext: "",
        value: "",
        required: false,
      },
    ],
  };
};
